import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnChanges,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarMonthViewDay,
  CalendarView,
} from 'angular-calendar';
import { EventColor } from 'calendar-utils';
import localeEs from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CandidatStatusOnMission, FlagType, userType } from '../utils/enums';
import { PlanningMissionDetailsComponent } from '../../pages/etablissement/planning/mission-details/mission-details.component';
import { AddDisponibilityComponent } from '../../pages/candidat/planning-candidat/add-disponibility/add-disponibility.component';
import { MissionService } from '../../services/mission.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { AuthService } from '../../services/auth.service';
import { AlertDialogService } from '../../services/alert-dialog.service';
import { FlagService } from '../services/flag.service';
import { log } from 'console';

const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent implements OnChanges{
  @Input() header: string = '';
  @Input() disponibilityDays: any;
  @Output() AddDisponibility = new EventEmitter<any>();
  @Output() RemoveDisponibility = new EventEmitter<any>();
  @Input() actionBtn: boolean = false;
  @Input() isCandidat: boolean = false;
  @Input() data: any[] = [];
  @Input() user: any = {};
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  DateDisabled = [];
  viewDate: Date = new Date();
  sameMonth: boolean = false;
  showResetButton: boolean = false;
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh = new Subject<void>();

  @Input() events: CalendarEvent[] = [
  
  ];
  locale: string = 'fr';
  isHovered = false;
  backgroundColor: string = '#FFC114';
  isSameDay = isSameDay;
  isSameMonth = isSameMonth;
  activeDayIsOpen: boolean = false;
  constructor(
    private dialog: MatDialog,
    private missionApi: MissionService,
    private auth: AuthService,
    private alertDialogService: AlertDialogService,
    private flag: FlagService,
  ) {
    registerLocaleData(localeEs);
  }

  ngOnChanges(e: any) {
    console.log(e);
    
  }
  ngOnInit(): void {    
    this.data = this.data.sort(function (a, b) {
      return b.startDate - a.startDate;
    });
    if (this.events?.length !== 0) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = false;
    }
  }
  ngAfterViewInit(): void {
  }
  resetDate(): void {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation de la suppression de toutes vos dates de non-disponibilité.',
        `Êtes-vous sûr(e) de vouloir supprimer toutes vos dates de non-disponibilité ?`,
        'OUI',
        'NON',
        '550px',
        false
      )
      .subscribe((res) => {
        if (res) {
          this.RemoveDisponibility.emit();
        }
      });
  }
  openAddDisponibility() {
    const dialogRef = this.dialog.open(AddDisponibilityComponent, {
      width: '680px',
      height: '286px',
      // position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: new Date(),
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.AddDisponibility.emit(result);
      setTimeout(() => {}, 500);
    });
  }
  dayClickedAvailable(
    {
      date,
      events,
      cssClass,
      backgroundColor,
    }: {
      date: Date;
      events: CalendarEvent[];
      cssClass?: string;
      backgroundColor?: any;
    },
    removeDisponibility: boolean,
    viewDate?: any
  ): void {
    if (this.actionBtn) {
      this.missionApi.addAvailableDay(this.user?.id, {
        toDate: moment(date).format('YYYY-MM-DD'),
        fromDate: moment(date).format('YYYY-MM-DD'),
      }).subscribe({
        next: ({ r }) => {
            this.AddDisponibility.emit(true);
        },
        error: (err) => {
      
        },
      });
    }  
  }
  isDateBeforeToday(date: Date): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0); 

  date.setHours(0, 0, 0, 0); 

  return date < today;
}
  dayClicked(
    {
      date,
      events,
      cssClass,
      backgroundColor,
    }: {
      date: Date;
      events: CalendarEvent[];
      cssClass?: string;
      backgroundColor?: any;
    },
    removeDisponibility: boolean,
    viewDate?: any
  ): void {
    if (this.isDateBeforeToday(date))
    {
      this.flag.displayFlag(
          'La date saisie est inférieure à aujourd’hui.',
          FlagType.error
        );
        this
      
      return;
    }
    if (this.actionBtn) {
      if (!cssClass) {
        const dialogRef = this.dialog.open(AddDisponibilityComponent, {
          width: '680px',
          height: '286px',
          // position: { right: '0' },
          backdropClass: 'bg-transparent',
          data: { date, removeDisponibility: false },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.AddDisponibility.emit(result);
            // window.location.reload();
          }
          setTimeout(() => {}, 500);
        });
      }
      else {
        if (removeDisponibility) {
          const dialogRef = this.dialog.open(AddDisponibilityComponent, {
            width: '680px',
            height: '286px',
            // position: { right: '0' },
            backdropClass: 'bg-transparent',
            data: { date, removeDisponibility: false },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.RemoveDisponibility.emit({
                start: result.start,
                end: result.end,
                id: backgroundColor,
              });
            }
            setTimeout(() => {
              this.setView(this.view);
            }, 500);
          });
        } else {
          const dialogRef = this.dialog.open(AddDisponibilityComponent, {
            width: '680px',
            height: '286px',
            // position: { right: '0' },
            backdropClass: 'bg-transparent',
            data: { date, removeDisponibility: false },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.AddDisponibility.emit(result);
            }
            setTimeout(() => {
              this.setView(this.view);
            }, 500);
          });
        }
      }
    } else {
      if (isSameMonth(date, this.viewDate)) {
        // if (
        //   isSameDay(this.viewDate, date) ||
        //   events.length !== 0
        // ) {
        //   this.activeDayIsOpen = false;
        // } else {
        //   this.activeDayIsOpen = false;
        // }
        this.viewDate = date;
      }
    }
  }
  mouseEnterEvent(id: any) {
    this.actionBtn = false;
    this.isHovered = true;
    var els = document.querySelectorAll("[id^='" + id + "']");

    els.forEach((el: any) => {
      if (el.id == id) {
        el.style.background = '#ffc01485';
      }
    });
  }
  mouseLeaveEvent(id: any) {
    var els = document.querySelectorAll("[id^='" + id + "']");
    this.actionBtn = true;
    this.isHovered = false;
    els.forEach((el: any) => {
      if (el.id == id) {
        el.style.background = '#FFC114';
      }
    });
  }
  ngOnInitDate(date: any) {
    this.sameMonth =
      new Date(date.period.start).getMonth() == new Date().getMonth();
    this.beforeMonthViewRender(date);
  }
  toDay(date: any) {
    setTimeout(() => {
      this.sameMonth = new Date(date).getMonth() == new Date().getMonth();
    }, 100);
  }
  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }
  // fetshMission(): void {
  //   this.api.getMissions().subscribe({
  //     next: (res) => {},
  //     error: (err) => {},
  //     complete: () => {},
  //   });
  // }
  handleEvent(action: string, event: any): void {
    this.modalData = { event, action };
    if (event && this.isHovered) {
      this.dialog.open(PlanningMissionDetailsComponent, {
        width: '666px',
        height: '100vh',
        position: { right: '0' },
        backdropClass: 'bg-transparent',
        data: { ...event?.data, candidat: this.user },
      });
    }
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors['red'],
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }
  closeOpenMonthViewDay(date: any) {
    this.activeDayIsOpen = false;
    setTimeout(() => {
      this.sameMonth = new Date(date).getMonth() == new Date().getMonth();
    }, 100);
  }
  beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
    body?.forEach((day) => {
      this.disponibilityDays?.map((el: any) => {
        if (
          new Date(el?.fromDate) <=
            new Date(moment(new Date(day.date)).format('YYYY-MM-DD')) &&
          new Date(el?.toDate) >=
            new Date(moment(new Date(day.date)).format('YYYY-MM-DD'))
        ) {
          day.cssClass = 'cal-disabled';
          day.backgroundColor = el?.id;
        }
      });
    });
    try {
        if (this.disponibilityDays && this.disponibilityDays?.length>0)
        { 
          this.showResetButton = true;
        }
    else {
      this.showResetButton = false;
    }  
    } catch {
      
    }

  }

 isSameMonthDate(date1: Date, date2: Date): boolean {
  if (!date1 || !date2) {
    return false;
   }
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDay() === date2.getDay();
}
}
